module.exports = __webpack_public_path__ + "static/media/charles-deluvio-Lks7vei-eAg-unsplash.49dbe9a1.jpg";